import fieldsMap from "../../../../lib/path-resolver-middlewares/ssr/map.categories[id].fields";
import FullFiedlsMap from "../../../../lib/path-resolver-middlewares/ssr/map.categories[name].fields";
import { QuickFiltersFieldsUiSpec } from "../../../../lib/path-resolver-middlewares/ssr/quickFilters.fields.ui";
import { SearchFieldsUiSpec } from "../../../../lib/path-resolver-middlewares/ssr/search.fields.ui";

export function getSearchCategoryFields(category = 0) {
  const categoryFields = (fieldsMap[category]?.search || []).concat([
    "near_bus",
    "near_metro",
  ]);
  return categoryFields
    .map((fieldName) => SearchFieldsUiSpec[fieldName])
    .filter((value) => value);
}
export function getQuickFiltersCategoryFields(category = 0) {
  return [
    (fieldsMap[category]?.quick.base || [])
      .map((fieldName) => QuickFiltersFieldsUiSpec(category)[fieldName])
      .filter((value) => value),
    (fieldsMap[category]?.quick.more || [])
      .map((fieldName) => QuickFiltersFieldsUiSpec(category)[fieldName])
      .filter((value) => value),
  ];
}

export function getCategoryFields(category = 0) {
  return (fieldsMap[category]?.fields || [])
    .map((fieldName) => FullFiedlsMap[fieldName])
    .filter((value) => value);
}
export function getCategoryExtendedFields(category = 0) {
  return (fieldsMap[category]?.extended_fields || [])
    .map((fieldName) => FullFiedlsMap[fieldName])
    .filter((value) => value);
}

function getCategoryUri(category = 0) {
  return fieldsMap[category]?.uri;
}

export default function handler(req, res) {
  const { category } = req.query;
  res.status(200).json({
    searchFields: getSearchCategoryFields(category),
    quickFields: getQuickFiltersCategoryFields(category),
    fields: getCategoryFields(category),
    extendedFields: getCategoryExtendedFields(category),
    uri: getCategoryUri(category),
  });
}
